export function Lightning({
  className,
  width = 22,
  height = 28,
}: {
  className?: string;
  width?: number;
  height?: number;
}) {
  return (
    // biome-ignore lint/a11y/noSvgWithoutTitle: <explanation>
    <svg
      width={width}
      height={height}
      viewBox="0 0 22 28"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <g>
        <g filter="url(#filter0_i_3915_5894)">
          <path
            d="M14.6579 2.84175L2.93749 15.0764L10.1882 16.9344L6.93985 26.2607L18.6603 14.026L11.4096 12.168L14.6579 2.84175Z"
            fill="#F55036"
          />
        </g>
      </g>
      <defs>
        <filter
          id="filter0_i_3915_5894"
          x="2.9375"
          y="2.8418"
          width="16.1266"
          height="23.818"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="BackgroundImageFix"
            result="shape"
          />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dx="0.4" dy="0.4" />
          <feGaussianBlur stdDeviation="1" />
          <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.2 0"
          />
          <feBlend
            mode="normal"
            in2="shape"
            result="effect1_innerShadow_3915_5894"
          />
        </filter>
      </defs>
    </svg>
  );
}
